import React from 'react'
import { Paper } from '@material-ui/core'

const PageNotFound = () => {
  return (
    <Paper style={{ margin: '50px 20px 0 20px', padding: '40px' }}>
      <h3>Page not found :(</h3>
      Maybe the page you are looking for has been removed, or you typed in the
      wrong URL
    </Paper>
  )
}

export default PageNotFound
